<template>
  <v-card
    class="top-card-style overflow-y-auto">
    <v-app-bar
      app
      color="#333f48"
      dark
      scroll-target="#scrolling-techniques-6"
    >
      <v-toolbar-title>Theory Assessment</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-img
        max-width="70"
        max-height="130"
        src="@/assets/img/logo/logo-green-light.svg"></v-img>
    </v-app-bar>
  </v-card>
</template>
<script>
export default {
  name: 'AppNavigation',
};
</script>

<style lang="scss">
.logo-style {
  margin-bottom: .2em
}
.top-card-style {
  border-radius: 0 0 12 12;
}
</style>
